module.exports = {
  siteTitle: 'Resume - Jason Long', // <title>
  manifestName: 'Resume',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-resume/`, // This path is subpath of your hosting https://domain/portfolio
  firstName: 'Jason',
  lastName: 'Long',
  // social
  socialLinks: [{
    icon: 'fa-github',
    name: 'Github',
    url: 'https://github.com/longjasonm',
  },
  {
    icon: 'fa-linkedin-in',
    name: 'Linkedin',
    url: 'https://linkedin.com/in/jasonmlong/',
  },
  {
    icon: 'fa-twitter',
    name: 'Twitter',
    url: 'https://twitter.com/longjasonm',
  },
  ],
  email: 'longjasonm@gmail.com',
  phone: '919-633-8417',
  address: 'Raleigh, NC',
  introParagraph: 'I am an experienced sales and solution engineer with expertise in front end development, UI/UX design, enterprise architecture and APIs/integration strategy. I\'m always on the lookout for opportunities to inform, educate, and sell great products for rapidly-growing, well-run, dynamic companies.',
  experience: [
    {
      jobTitle: 'Manager, Solutions Engineering - Enterprise/Strategic Accounts',
      promotedFrom: 'Senior Solutions Engineer, Team Lead, AMER East/Central',
      companyName: 'Algolia',
      companyLink: 'https://algolia.com/',
      description: `<p>Algolia is a hosted search and discovery engine with powerful APIs that let developers quickly and seamlessly integrate a powerful search and recommendation experience on any website or application.</p>
      <p>I serve as the leader of an 8-person SE team, distributed across the US, LATAM and ANZ. Our team is responsible for delivering demos, architecture, and solutions for Algolia's largest, most complex prospects and customers. As a manager, my role is to remove the barriers to success, giving my team the time and freedom to do their best work. To do this, I focus on balancing workload, continuing education, and overall wellness and morale of my team members.</p>`,
      timeFrameBegin: 'November 2020',
      timeFrameEnd: 'Present'
    },
    {
      jobTitle: 'Lead Solution Engineer',
      promotedFrom: 'Senior Solution Engineer',
      companyName: 'Salesforce',
      companyLink: 'https://www.salesforce.com/',
      description: `<p>I have served as a Enterprise Solution Engineer for the Salesforce Commerce Cloud, specifically B2C Commerce (formerly Demandware), Salesforce Order Management and Salesforce CMS.</p>
    <ul>
      <li>Contributed to over $40M in pipeline and $15M in closed won business</li>
      <li>Specialized in non-retail/innovation use cases for Salesforce commerce practice</li>
      <li>Built custom demo environments, including branding and design, data scraping tools for e-commerce catalogs, and persona development</li>
      <li>Developed internal demos on headless commerce capabilities, including demo of Algolia integration to B2C Commerce</li>
      <li>🏆 FY19 Commerce Cloud Solution Engineer of the Year</li>
      <li>Trailhead Ranger</li>
    </ul>`,
      timeFrameBegin: 'May 2017',
      timeFrameEnd: 'November 2020'
    },
    {
      jobTitle: 'Senior Solution Engineer',
      companyName: 'The Pedowitz Group',
      companyLink: 'http://www.pedowitzgroup.com/',
      description: `<p>Led technology architecture workshops for clients and set the advanced technical direction on engagements. Clients include Fortune 500 enterprises in the financial services, entertainment, and software sectors, and numerous startup and mid-size B2B software companies.</p>
        <ul>
        <li>Responsible for entire consulting lifecycle, including gathering client requirements, working with a team to determine the best solution and successfully delivering that solution, including documentation and knowledge transfer.</li>
        <li>Provide technical knowledge/support and project scoping in support of the sales team through all points of the sales process.</li>
        <li>Serve as a technology expert/mentor/thought leader, both internally and externally, in advanced Web front-end technologies and techniques, including HTML/CSS/JavaScript, Node.js, Web Development tools (task runners, build systems, templating engines).</li>
        <li>Design/build custom solutions within and between Marketing Automation Solutions (Marketo, Eloqua, ExactTarget), CRM Platforms (Salesforce.com, NetSuite, Quickbase) and other marketing/sales solutions using REST APIs, Dell Boomi, Zapier and other Web technologies and approaches.</li>`,
      timeFrameBegin: 'December 2014',
      timeFrameEnd: 'January 2017'
    },
    {
      jobTitle: 'Director of Marketing',
      companyName: 'ServiceTrade',
      companyLink: 'http://www.servicetrade.com/',
      description: `<p>Employee #10 at this SaaS field service management company, I was responsible for driving qualified leads, opportunities and revenue through marketing. Implemented end-to-end sales and marketing stack and responsible for all marketing and sales operations (Marketo, SFDC) along with coordinating and measuring ROI from all marketing channels (events, online advertising, content syndication).</p>`,
      timeFrameBegin: 'November 2013',
      timeFrameEnd: 'December 2014'
    },
    {
      jobTitle: 'Director of Revenue Marketing',
      promotedFrom: 'Revenue Engineer',
      companyName: 'The Pedowitz Group',
      companyLink: 'http://www.pedowitzgroup.com/',
      description: `<ul>
        <li>Manage a team of marketing specialists to drive brand awareness and sales-ready leads for
        demand generation agency
        <li>Developed tailored processes for marketing collateral production, lead qualification, content
        marketing effectiveness and closed-loop revenue reporting</li>
        <li>Serve as administrator and power user for all marketing systems and processes, including website, CRM, marketing automation platform, social media monitoring and analytics</li>
        <li>Responsible for multichannel marketing campaign calendar and coordinate all aspects of launch (email, social media, paid advertising) and reporting (leads, A/B testing, pipeline, revenue)</li>
        </ul>`,
      timeFrameBegin: 'November 2013',
      timeFrameEnd: 'December 2014'
    }
  ],
  education: [{
    schoolName: 'Virginia Military Institute',
    degree: 'B.A. International Studies, B.A. Modern Languages (Spanish)',
    gpa: '3.62',
    description: `<ul>
      <li>Distinguished Graduate with Institute Honors (Top 15 in Class)</li>
      <li>Editor-in-Chief - THE CADET Newspaper, where I was responsible for an editorial staff of 20 and full P&L for weekly newspaper</li>
      <li>Regimental S-3 (Operations) Lieutenant for 1,200-student Corps of Cadets</li>
      <li>Additonal Activities: College Bowl Team, Parade Announcer, Campus Tour Guide</li>
      </ul>`,
    timeFrameBegin: 'August 2002',
    timeFrameEnd: 'May 2006'
  }],
  skills: `
  <ul>
  <li><b>Markup:</b> HTML5, CSS3, Handlebars, ISML (Salesforce Commerce scripting language), JavaScript/jQuery, Liquid</li>
  <li><b>Server-side:</b> JavaScript, Nodejs, React, PHP, .NET, Visualforce, Lightning Web Components</li>
  <li><b>SaaS/Platforms:</b> Salesforce, Demandware, Shopify, Heroku, CMS (Ektron, Sitecore, WordPress, Drupal)</li>
  <li><b>Workflow/Tools/Apps:</b> Github, Bitbucket, Gulp/Grunt, NPM/yarn/npx, Figma, Adobe XD, Adobe Photoshop, VSCode, Salesforce Sales Cloud, Salesforce Service Cloud, Zendesk</li>
  </ul>
  `,
  interests: `When I'm not working and helping my awesome wife raise our 3 young kids, I enjoy playing golf, hockey, boating, cooking, and traveling!`,
  references: 'Available upon request.',
  colophon: `<small>This resume was built using <a href="https://reactjs.org/">React</a> and <a href="https://www.gatsbyjs.com/">Gatsby</a>, deployed on <a href="https://netlify.app/">Netlify</a>, and the source can be found on <a href="https://www.github.com/longjasonm/gatsby-resume">Github</a>.</small>`
};